var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "title": "预览",
      "visible": _vm.dialogVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.baseData) ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("邮件标题：" + _vm._s(_vm.baseData.name))]), _vm._v(" "), _c('p', [_vm._v("发送时间：" + _vm._s(_vm.baseData.sendTime))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.baseData.content)
    }
  })])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2d5d84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/viewEmailHistoryItem.vue
// module id = null
// module chunks = 